import { useCallback, useEffect, useMemo, useState } from "react";

import appStore from "@Stores/app";

import { usePageStore } from "../../../store";

export const getURL = ({ hasCms, protocol, domain, route, pageId, params }) => {
  const url = new URL(`${protocol}://${domain}`)

  if (hasCms && route) {
    url.pathname = route
  }

  if (process.env.NODE_ENV === 'development') {
    url.port = hasCms ? 3002 : 3000
  }

  if (hasCms) {
    const searchParams = new URLSearchParams()

    searchParams.append("is_test", true)
    searchParams.append("ephemeral", true)
    searchParams.append("pageOverride", pageId)
    searchParams.append("offer_target_post", true)

    Object.entries(params).forEach(([key, value]) => {
      if (![undefined, null, ""].includes(value)) {
        searchParams.append(key, value)
      }
    })

    url.search = searchParams.toString()
  }

  return url.toString()
}

export const getScriptURL = () => {
  if (process.env.NODE_ENV === 'development') {
    return '//localhost:3000/scripts/embed.js'
  }
  return '//path.twyne.io/scripts/embed.js'
}

export const getApiURL = () => {
  if (process.env.NODE_ENV === 'development') {
    return '//localhost:3000'
  }
  return ''
}

export const parseValue = value => {
  if ([undefined, null, ""].includes(value)) {
    return `''`
  }
  if (typeof value === 'boolean') {
    return value
  }
  return `'${value}'`
}

export const getRandomEmail = () => {
  const random = Date.now().toString(16)
  return `${random}@qa.com`
}

export const getData = () => ({
  incommingTraffic: {
    aid: null,
    pid: null,
    __testab_offer: null,
    sid1: '',
    sid2: '',
    sid3: '',
  },
  consumer: {
    first_name: 'Test1',
    last_name: 'Test2',
    email: getRandomEmail(),
    address1: '',
    address2: '',
    city: 'Denver',
    state: 'CO',
    zip: '',
    phone: '',
  },
})

export const parseParams = data => {
  const params = {}
  Object.values(data).forEach(values => {
    Object.entries(values || {}).forEach(([key, value]) => params[key] = value)
  })
  return params
}

export const useSite = () => {
  const { id, domain_aliases: aliases, domain, organization, viewdir } = appStore.site
  const { cms } = organization || {}

  const [domains, setDomains] = useState([])

  useEffect(() => {
    if (!aliases) return;
    setDomains(() => aliases.split(",")
      .filter(domain => !domain?.includes("*"))
      .map(domain => {
        domain = JSON.parse(domain)
        return { label: domain, value: domain }
    }))
  }, [aliases])

  return useMemo(() => ({
    siteId: id,
    defaultDomain: domain,
    domains,
    hasCms: viewdir !== "embed" || cms,
  }), [id, domain, domains, cms, viewdir])
}

export const useRoutes = () => {
  const { lists: { "cms/routes": { items, useLoad } } } = usePageStore()
  const [routes, setRoutes] = useState([])

  useLoad()

  const loadRoutes = useCallback(async routes => {
    setRoutes(() => routes.map(({ path }) => {
      path = path.substring(1, path.length)
      return { label: `/${path}`, value: path }
    }))
  }, [])

  useEffect(() => {
    loadRoutes(items)
  }, [items, loadRoutes])

  return useMemo(() => ({
    routes,
  }), [routes])
}
